import "./InPaint.css";
import React, { Component } from "react";
import ImageLoader from "./common/ImageLoader";
import TextPrompt from "./TextPrompt";
import { BsPenFill, BsFillEraserFill, BsTrash } from "react-icons/bs";
import { ImRedo, ImUndo } from "react-icons/im";
import { ReactSketchCanvas } from "react-sketch-canvas";


class InPaint extends Component {
    constructor(props) {
        super(props);
        this.canvas = React.createRef();
        // this.myRef = React.createRef();
        // this.cropperRef = React.createRef();
    }
    state = {
        color: "#00FF00",
        penSize: 10,
        openModal: false,
        isEraser: false,
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
    }



    componentDidMount() {
        window.addEventListener('resize', this.handleWindowResize);
    }

    handlePenSizeChange = (size) => {

        this.setState({ penSize: size });
    }

    handlePenMode = (isEraser) => {
        this.canvas.current.eraseMode(isEraser)
        this.setState({ isEraser })
    }

    handleRedo = () => {
        this.canvas.current.redo()
    }

    handleUndo = () => {
        this.canvas.current.undo()
    }




    handleSubmit = (prompt) => {

        this.canvas.current
            .exportImage("png")
            .then(async (data) => {
                await this.props.handleSketchSave(data);
                await this.props.submit(prompt);
            })
            .catch(e => {
                console.log(e);
            });

    }


    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowResize);
    }

    handleWindowResize = () => {
        this.setState({
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight
        });
    }


    render() {
        const { windowWidth, windowHeight } = this.state;
        let w;
        if (windowWidth > 800) {
            w = Math.round(windowWidth * .7);
            w = Math.round(Math.min(w, .6 * windowHeight));
            w = (w - 15).toString() + "px"
        } else {
            w = windowWidth > 576 ? "576px" : (windowWidth - 15).toString() + "px";
        }
        const bgImage = this.props.initImageURL;
        let width;
        let height;
        if (this.props.galeryItem && "width" in this.props.galeryItem) {
            width = this.props.galeryItem.width;
            height = this.props.galeryItem.height;
        } else {
            width = 512;
            height = 512;
        }
        console.log(width, height)
        return (
            <div className="container-inpaint" >
                <div style={{ color: "white", textAlign: "center", fontSize: "10pt", margin: "5px" }}>Inpaint</div>

                {/* <div className="canvas-container-inpaint"> */}
                {this.props.loading
                    ? <ImageLoader />
                    : null
                }
                <div className="inpaint-canvas-container"
                // style={{ overflowX: "scroll", width: "100%" }}
                >
                    <ReactSketchCanvas
                        ref={this.canvas}
                        strokeWidth={this.state.penSize}
                        strokeColor={this.state.color}
                        exportWithBackgroundImage={false}
                        // preserveBackgroundImageAspectRatio="xMidYMid"
                        backgroundImage={bgImage}
                        // className="inpaint-canvas"
                        width={width}
                        height={height}
                        style={{ border: 0, margin: "auto" }}

                    />
                </div>

                <div className="tool-container-inpaint" style={{ width: w, margin: "auto" }} >
                    <div className="tool-color-inpaint">

                        <input
                            className="input-pen-size"
                            type="range"
                            min={2}
                            max={100}
                            value={this.state.penSize}
                            onInput={(e) => this.setState({ penSize: parseInt(e.currentTarget.value) })}
                            style={{ backgroundColor: this.state.color }}
                        />
                    </div>


                    <div className="tool-button-inpaint-cont">
                        <button className="tool-button-inpaint"
                            onClick={this.handlePenMode.bind(this, false)}
                            disabled={!this.state.isEraser}
                        >
                            <BsPenFill style={{ verticalAlign: "middle" }} size={18} />
                        </button>
                        <button className="tool-button-inpaint"
                            onClick={this.handlePenMode.bind(this, true)}
                            disabled={this.state.isEraser}
                        >
                            <BsFillEraserFill style={{ verticalAlign: "middle" }} size={18} />
                        </button>
                        <button className="tool-button-inpaint"
                            onClick={this.handleUndo}
                        >
                            <ImUndo style={{ verticalAlign: "middle" }} size={18} />
                        </button>
                        <button className="tool-button-inpaint"
                            onClick={this.handleRedo}
                        >
                            <ImRedo style={{ verticalAlign: "middle" }} size={18} />
                        </button>
                        <button className="tool-button-inpaint"
                            onClick={() => this.canvas.current.resetCanvas()}
                        >
                            <BsTrash style={{ verticalAlign: "middle" }} size={18} />
                        </button>
                    </div>


                </div>

                <TextPrompt
                    submit={this.handleSubmit}
                    prompt={this.props.prompt}
                />


            </div >
        );
    }
};

export default InPaint;